"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.includeInArray = void 0;
/**
 * Optionally include items in an array
 * Useful for building menu options from permissions groups, or button sets
 */
var includeInArray = function (include, option) { return __spreadArray([], (include ? [option] : []), true); };
exports.includeInArray = includeInArray;
